const topics = [
  
// READY TO ADD INFORMATION HERE

  // 1.B.1.1 — Cultural practices & traditions
  { title: "Holidays", slug: "holidays", standardNumber: "1.B.1", description: "", gameType: "multipleChoice", titleImage: "", video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fholidays3rdgradeva.mp4?alt=media&token=9b8c3d1d-efbb-476b-b040-86df66f25236", music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fholidays3rdgrade2022.mp3?alt=media&token=b1ef8a09-e63d-4a65-817e-eb1bdfccc528", lyrics: ["(Verse)",
"One day in January we remember",
"a man who worked hard so all people would be treated equal.",
"It’s a holiday,",
"Martin Luther King Jr. Day.",
"It’s a holiday,",
"Martin Luther King Jr. Day.",

"One day in February is for the greats.",
"We honor all presidents of The United States.",
"It’s a holiday,",
"Presidents Day.",
"It’s a holiday,",
"Presidents Day.",

"One day in May we remember",
"Americans who died during war while serving our country.",
"It’s a holiday,",
"Memorial Day.",
"It’s a holiday,",
"Memorial Day.",

"On the Fourth of July we celebrate",
"becoming a new country, America’s birthday.",
"It’s a holiday,",
"Independence Day, The 4th of July.",
"It’s a holiday,",
"Independence Day, The 4th of July.",

"One day in November we remember",
"Americans who served in the military.",
"It’s a holiday,",
"Veterans Day.",
"It’s a holiday,",
"Veterans Day.",

"© Smart Board Learning, LLC. All rights reserved.",] },
  { title: "Pledge", slug: "pledge", standardNumber: "1.B.1", description: "", gameType: "multipleChoice", titleImage: "", video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fpledge.mp4?alt=media&token=c4877dc3-d775-42d5-b8e0-960352101e3f", music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fpledge.mp3?alt=media&token=c712b543-9b61-437e-944c-02c04b85a3eb", lyrics: ["(verse)",
"The leader of the United States",
"is the President, is the President.",
"The leader of the United States",
"is the President, is the President.",

"(verse)",
"The American Flag is red, white and blue,",
"with white stars, red and white stripes.",
"The American Flag is red, white and blue,",
"with white stars, red and white stripes.",

"(verse)",
"When we pledge to the American Flag",
"we recite the Pledge of Allegiance.",

"(verse)",
"I pledge allegiance to the Flag of the United States of America,",
"and to the Republic for which it stands, one Nation under God, indivisible, with liberty and justice for all.",

"(verse)",
"When we pledge to the American Flag",
"we recite the Pledge of Allegiance.",
"When we pledge to the American Flag",
"we recite the Pledge of Allegiance.",

"© Smart Board Learning, LLC. All rights reserved.",] },
  { title: "American Flag", slug: "americanflag", standardNumber: "1.B.1", description: "", gameType: "multipleChoice", titleImage: "", video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Famericanflag2025video.mp4?alt=media&token=756a44ba-d6af-41b4-bd71-bc2db4f1c554", music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Famericanflag2025song.mp3?alt=media&token=1331c218-f3c0-4069-bee1-01085c9823df", lyrics: ["(Chorus)",
"Our flag, our flag, our flag fly free.",
"Our flag, our flag, our flag’s in me.",
"Fifty stars, thirteen stripes.",
"Flying high, so bold and bright.",

"(Verse 1)",
"With stars and stripes, here we stand.",
"A flag waves proudly, across the land.",
"Through the breeze we see freedom dance.",
"Come one, come all, come take a chance.",
"With fifty stars, we see them blooming,",
"As the 50 States of the Union.",
"Thirteen stripes will always follow me,",
"And represent the thirteen original colonies.",

"(Chorus)",
"Our flag, our flag, our flag fly free.",
"Our flag, our flag, our flag’s in me.",
"Fifty stars, thirteen stripes.",
"Flying high, so bold and bright.",

"(Verse 2)",
"Patriotism is in everyone’s heart.",
"A love for our country, a love with a spark.",
"In its colors, find joy and pride.",
"The America's spirit will forever fly.",
"With fifty stars, we see them blooming,",
"As the 50 States of the Union.",
"Thirteen stripes will always follow me,",
"And represent the thirteen original colonies.",

"(Chorus)",
"Our flag, our flag, our flag fly free.",
"Our flag, our flag, our flag’s in me.",
"Fifty stars, thirteen stripes.",
"Flying high, so bold and bright.",

"© Smart Board Learning, LLC. All rights reserved.",] },
  { title: "As Americans", slug: "asamericans", standardNumber: "1.B.1", description: "", gameType: "multipleChoice", titleImage: "", video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fsocial-studies-videos%2Fasamericansvideo.mp4?alt=media&token=061bf961-6f30-4193-a2a9-57d0c4945357", music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fasamericanssong.mp3?alt=media&token=3dac71a2-2944-49e6-94c5-125abbf4c845", lyrics: ["(chorus)",
        "The rights to life, liberty and the pursuit of happiness.",
        "The rights to life, liberty and the pursuit of happiness.",
        "The rights to life, liberty and the pursuit of happiness.",
        "The rights to life, liberty…",
        "(verse)",
        "We the American people come from many different ethnic origins.",
        "We the American people come from many different countries.",
        "The republican form of government principles unites us as Americans.",
        "The republican form of government principles unites us as Americans.",
        "(chorus)",
        "The rights to life, liberty and the pursuit of happiness.",
        "The rights to life, liberty and the pursuit of happiness.",
        "The rights to life, liberty and the pursuit of happiness.",
        "The rights to life, liberty and the pursuit of happiness.",
        "© Smart Board Learning, LLC. All rights reserved.",] },
  { title: "What is Culture?", slug: "whatisculture", standardNumber: "1.B.1", description: "", gameType: "multipleChoice", titleImage: "", video: "", music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fwhatisculture2025song.mp3?alt=media&token=e0abf045-87fb-49e1-a138-407f7a73a381", lyrics: ["(Chorus)",
"Culture is how we live each day,",
"what we eat and what we say!",
"How we dance and what we do.",
"Culture is me, and culture is you!",

"(Verse 1)",
"Culture is the way we speak,",
"english, Spanish, maybe Greek!",
"Some say 'hello,' some say 'hi,'",
"some say 'bonjour' when you walk by!",
"Culture is the food we share,",
"pizza, pasta, everywhere!",
"Rice and beans or mac and cheese,",
"different flavors, same great feast!",

"(Chorus)",
"Culture is how we live each day,",
"what we eat and what we say!",
"How we dance and what we do.",
"Culture is me, and culture is you!",

"(Verse 2)",
"Culture’s in the songs we sing,",
"banjo, drum, or violin!",
"Clap your hands and stomp your feet,",
"music makes our world complete!",
"Holidays and special days,",
"families celebrate different ways!",
"Fireworks, lights, a big parade,",
"traditions that will never fade!",

"(Chorus)",
"Culture is how we live each day,",
"what we eat and what we say!",
"How we dance and what we do.",
"Culture is me, and culture is you!",

"© Smart Board Learning, LLC. All rights reserved.",] },
  { title: "What is Belief", slug: "whatisbelief", standardNumber: "1.B.1", description: "", gameType: "multipleChoice", titleImage: "", video: "", music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fwhatisbelief2025song.mp3?alt=media&token=88a35e67-628a-4f0b-8f85-974e20930d18", lyrics: [ "(Chorus)",
    "Beliefs are things we think are true.",
    "They're part of me, they're part of you!",
    "They help us know what’s wrong and right,",
    "and guide us every day and night!",
    "",
    "(Verse 1)",
    "Some believe in helping out,",
    "sharing kindness all about.",
    "Some believe in being fair,",
    "showing love and showing care!",
    "Some believe in family ways,",
    "special meals and holiday days.",
    "Some believe in telling the truth,",
    "honest words from me to you!",
    "",
    "(Chorus)",
    "Beliefs are things we think are true.",
    "They're part of me, they're part of you!",
    "They help us know what’s wrong and right,",
    "and guide us every day and night!",
    "",
    "(Verse 2)",
    "Different people, different views,",
    "but we respect what others do.",
    "We can learn from what they say,",
    "and live in kindness every day!",
    "Different people, different views,",
    "but we respect what others do.",
    "We can learn from what they say,",
    "and live in kindness every day!",
    "",
    "(Chorus)",
    "Beliefs are things we think are true.",
    "They're part of me, they're part of you!",
    "They help us know what’s wrong and right,",
    "and guide us every day and night!",
    "",
    "© Smart Board Learning, LLC. All rights reserved.",
        ] },

  // 1.B.1.2 — Diverse people shaping community
  { title: "People", slug: "people", standardNumber: "1.B.1", description: "", gameType: "multipleChoice", titleImage: "", video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fpeople2025video.mp4?alt=media&token=957a3212-a73d-4f78-a3b1-dc6a4079acd3", music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fpeople2025song.mp3?alt=media&token=8359150c-fa84-4aa0-8283-e4a3fe001ef4", lyrics: ["(chorus)",
"People from our past.",
"These are people from our past.",

"(verse)",
"George Washington was our 1st President.",
"George Washington was our 1st President.",
"He was called the Father of our Country.",
"He was called the Father of our Country.",
"Abraham Lincoln was our 16th President.,",
"Abraham Lincoln was our 16th President.",
"He was called Honest Abe.",
"He was called Honest Abe.",
"Betsy Ross, a long time ago, had sewn one of the first American flags.",
"Betsy Ross, a long time ago, had sewn one of the first American flags.",

"(chorus)",
"People from our past.",
"These are people from our past.",
"These are people from our past.",

"(verse)",
"George Washington was our 1st President.",
"George Washington was our 1st President.",
"He was called the Father of our Country.",
"He was called the Father of our Country.",
"Abraham Lincoln was our 16th President.",
"Abraham Lincoln was our 16th President.",
"He was called Honest Abe.",
"He was called Honest Abe.",
"Betsy Ross, a long time ago, had sewn one of the first American flags.",
"Betsy Ross, a long time ago, had sewn one of the first American flags.",

"(chorus)",
"People from our past.",
"These are people from our past.",
"These are people from our past.",

"© Smart Board Learning, LLC. All rights reserved.",] },
  { title: "Native Contributions", slug: "nativecontributions", standardNumber: "1.B.1", description: "", gameType: "multipleChoice", titleImage: "", video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fnativecontributions2025video.mp4?alt=media&token=ac5568b5-1a71-46c5-bd19-d1f7a1d74277", music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fnativedifferences2025song.mp3?alt=media&token=14be9668-7f68-4ab1-a9a7-41a30df34a14", lyrics: ["(chorus)",
"Native American contributions that we use today,",  
"Native American contributions that we use today,",  
"Native American contributions that we use today,",  
"Native American contributions that we use today.",  

"(verse 1)",
"Native American culture taught us things that live on.",  
"They taught us about the farming of tobacco,",  
"they taught us about the farming of corn.",  
"Native American culture taught us things we can't forget.",  
"We learned to respect nature and gain knowledge of the environment.",  
"Native American culture brought things we love in the heart.",  
"They brought us pottery, weaving, carving, and different types of arts.",  

"(chorus)",
"Native American contributions that we use today,",  
"Native American contributions that we use today,",  
"Native American contributions that we use today,",  
"Native American contributions that we use today.",  

"© Smart Board Learning, LLC. All rights reserved.",] },

  // 1.B.1.3 — Artistic expressions in communities

  // 1.B.1.4 — Beliefs/values influence resolving disagreements
  // (no direct song match — leave empty or placeholder if you want)

  // 1.C&G.1 — Civic engagement
  { title: "Responsible Citizen", slug: "responsiblecitizen", standardNumber: "1.C&G.1", description: "", gameType: "multipleChoice", titleImage: "", video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fresponsiblecitizen2025video.mp4?alt=media&token=c686e9e2-9c58-4d29-88ac-75835950a857", music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fresponsiblecitizen2025song.mp3?alt=media&token=4fe0f14e-695b-4155-8ad4-696cbe08b452", lyrics: ["(Chorus)",
"I will be a responsible American citizen,",
"Because I love this country that we are living in.",
"I will be a responsible American citizen,",
"Because I love this country that we are living in.",

"(Verse)",
"Responsible citizens have civic duties.",
"Responsible citizens obey laws.",
"Responsible citizens serve on a jury,",
"Or as a witness, if they are called.",
"Responsible citizens have civic duties.",
"Responsible citizens pay their taxes.",
"Responsible citizens serve in the armed forces,",
"If they are called.",

"(Chorus)",
"I will be a responsible American citizen,",
"Because I love this country that we are living in.",
"I will be a responsible American citizen,",
"Because I love this country that we are living in.",

"© Smart Board Learning, LLC. All rights reserved.",] },
  { title: "The Government", slug: "thegovernment", standardNumber: "1.C&G.1", description: "", gameType: "multipleChoice", titleImage: "", video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fthegovernmentvideo2025old.mp4?alt=media&token=d00d2200-0963-42d4-a6e6-c83a60a4c5e1", music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fthegovernment.mp3?alt=media&token=34f24faf-493f-44b6-bf3b-13b82cd6d489", lyrics: ["(chorus)",
"Governments make laws to protect the",
"rights and the property of everyone.",
"Governments make laws to protect the",
"rights and the property of everyone.",

"(verse)",
"Laws are made to keep people safe.",
"Laws are made to keep people safe.",
"Laws are made so order can be maintained.",
"Laws are made so order can be maintained.",
"The job of the government is to make laws.",
"The job of the government is to carry out laws.",
"The job of the government is to decide if laws have been broken.",

"(chorus)",
"Governments make laws to protect the",
"rights and the property of everyone.",
"Governments make laws to protect the",
"rights and the property of everyone.",

"© Smart Board Learning, LLC. All rights reserved.",] },
  { title: "Capitol Building", slug: "capitolbuilding", standardNumber: "1.C&G.1", description: "", gameType: "multipleChoice", titleImage: "", video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fuscapitolbuilding.mp4?alt=media&token=13c614d2-d018-43aa-9dd3-5ad1c7044c10", music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2FThe%20Capitol%20Building%20-%20Final.mp3?alt=media&token=99e32872-1d38-49c2-ac5c-e6a68059e9a7", lyrics: ["(chorus)",
"This is our Capitol Building.",
"This is our Capitol Building.",
"This is our Capitol Building.",
"This is our Capitol Building.",

"(verse)",
"The Capitol building is where the US Congress meet.",
"100 Constitutional Ave. Northwest, Washington DC.",
"In the Capitol Building we have senators and the house of representatives.",
"Each representative represents the state that they live in.",
"The Capitol Building is over 200 years old, of course.",
"Congress meets at the Capitol Building to make and pass laws.",
"The statue on top of the dome is not misleading.",
"It represents the United States, and it’s called the Statue of Freedom.",

"(chorus)",
"This is our Capitol Building.",
"This is our Capitol Building.",
"This is our Capitol Building.",
"This is our Capitol Building.",

"© Smart Board Learning, LLC. All rights reserved.",] },
  // 1.C&G.1.4 — (no direct song match)

  // 1.E.1 — Economics
  { title: "Wants & Choices", slug: "wantsandchoices", standardNumber: "1.E.1", description: "", gameType: "multipleChoice", titleImage: "", video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fwantsandchoices2025video.mp4?alt=media&token=46126733-76e4-468d-8dfd-2b3605f22776", music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fwantsandchoices2025song.mp3?alt=media&token=0cab7c9d-c510-4459-8e07-bd57a18920e6", lyrics: ["(Verse)",
"Things that we would like to have are called wants.",
"That’s what we want.",
"We can choose between two or more things, that’s a choice.",
"We have a choice.",
"Some choices that we make are made because we can’t have everything we want,",
"we want.",

"Things that we would like to have are called wants.",
"That’s what we want.",
"We can choose between two or more things, that’s a choice.",
"We have a choice.",
"Some choices that we make are made because we can’t have everything we want,",
"we want.",

"© Smart Board Learning, LLC. All rights reserved.",] },
  { title: "Trade", slug: "trade", standardNumber: "1.E.1", description: "", gameType: "multipleChoice", titleImage: "", video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Ftradevideo2025old.mp4?alt=media&token=6dd9b138-4f02-42ee-9b97-3f804e60f7d7", music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Ftrade.mp3?alt=media&token=aa09d2a5-dedd-482a-aec6-e7c941b09d6e", lyrics: ["(verse)",
"Specialization is when people and regions,",
"make certain goods and provide certain services.",
"Specialization is when people and regions,",
"make certain goods and provide certain services.",
"Specialization is when people and regions,",
"make certain goods and provide certain services.",
"They trade with others to get what they don’t have.",
"They trade with others to get what they don’t have.",
"They trade with others to get what they don’t have.",
"They trade with others to get what they don’t have.",
"Specialization is when people and regions,",
"make certain goods and provide certain services.",
"Specialization is when people and regions,",
"make certain goods and provide certain services.",

"© Smart Board Learning, LLC. All rights reserved.",] },
  { title: "Barter", slug: "barter", standardNumber: "1.E.1", description: "", gameType: "multipleChoice", titleImage: "", video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fbarter2025video.mp4?alt=media&token=6345df74-466e-458e-b8c2-923c150215eb", music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fbarter2025song.mp3?alt=media&token=8ac562f6-6b71-49da-9b5c-7044b49d009a", lyrics: ["(chorus)",
"As a farmer, I would barter.",
"As a farmer, I would barter.",

"(verse)",
"Most people did not have paper money.",
"Most people did not have coins.",
"Most people did not have paper money.",
"Most people did not have coins.",

"(chorus)",
"As a farmer, I would barter.",
"As a farmer, I would barter.",

"(verse)",
"Barter means trading, barter means trading,",
"Or exchanging of goods without using money.",
"Tobacco was used as money.",
"You could trade tobacco for goods and services.",

"(chorus)",
"As a farmer, I would barter.",
"As a farmer, I would barter.",

"© Smart Board Learning, LLC. All rights reserved.",] },
  { title: "Producer", slug: "producer", standardNumber: "1.E.1", description: "", gameType: "multipleChoice", titleImage: "", video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fproducer2025video.mp4?alt=media&token=927f12da-8625-49c4-9b45-c6dc89b4ae06", music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fproducer2025song.mp3?alt=media&token=9907f02f-44ae-4bdc-a63d-241c0140ca0d", lyrics: ["(verse)",
"I make goods and I provide services.",
"I make goods and I provide services.",
"That makes me a producer,",
"that makes me a producer.",
"I make goods and I provide services.",
"I make goods and I provide services.",
"That makes me a producer,",
"that makes me a producer.",
"I use the goods and services that are made by the producers.",
"That makes me a consumer.",
"I use the goods and services that are made by the producers.",
"That makes me a consumer.",
"When resources are scarce, that means limited resources,",
"limited resources.",
"When resources are scarce, that means limited resources,",
"limited resources.",

"© Smart Board Learning, LLC. All rights reserved.",] },

  // 1.G.1 — Maps & geography
  { title: "Continents & Oceans", slug: "continentsandoceans", standardNumber: "1.G.1", description: "", gameType: "multipleChoice", titleImage: "", video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fcontinentsandoceans2021.mp4?alt=media&token=dfa953f5-3c7a-4eaa-8324-7c30ad8495ab", music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fcontinentsandoceans2025song.mp3?alt=media&token=8009685b-ddfb-459c-b393-739b04808f60", lyrics: ["(Verse)",
"There are seven continents in this world, in this world.",
"There are seven continents in this world, in this world.",
"Africa, Antarctica, Asia, Australia,",
"Europe, North America, South America.",
"There are seven continents in this world, in this world.",
"There are seven continents in this world, in this world.",
"Africa, Antarctica, Asia, Australia,",
"Europe, North America, South America.",

"There are five major oceans in this world, in this world.",
"There are five major oceans in this world, in this world.",
"The Pacific Ocean, the Atlantic Ocean, the Indian Ocean,",
"The Arctic, and Southern Ocean.",
"There are five major oceans in this world, in this world.",
"There are five major oceans in this world, in this world.",
"The Pacific Ocean, the Atlantic Ocean, the Indian Ocean,",
"The Arctic, and Southern Ocean.",

"There are seven continents in this world, in this world.",
"There are seven continents in this world, in this world.",
"Africa, Antarctica, Asia, Australia,",
"Europe, North America, South America.",
"There are five major oceans in this world, in this world.",
"There are five major oceans in this world, in this world.",
"The Pacific Ocean, the Atlantic Ocean, the Indian Ocean,",
"The Arctic, and Southern Ocean.",

"© Smart Board Learning, LLC. All rights reserved.",] },
  { title: "My Map", slug: "mymap", standardNumber: "1.G.1", description: "", gameType: "multipleChoice", titleImage: "", video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fmymap2025video.mp4?alt=media&token=3291496b-9cbc-4a61-8810-acb3cacf3f99", music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmymap2025song.mp3?alt=media&token=982b6c7f-d3c6-466b-9c7b-e77a491faf35", lyrics: ["(verse)",
"When we make a map,",
"when we make a map,",
"we must include the title.",
"That’s the name or kind of map.",
"When we make a map,",
"when we make a map,",
"we must include the title.",
"That’s the name or kind of map.",
"When we make a map,",
"when we make a map,",
"we must include the legend.",
"Symbols and what each one stands for.",
"When we make a map,",
"when we make a map,",
"we must include the legend.",
"Symbols and what each one stands for.",
"When we make a map",
"we must include a compass rose.",
"It shows directions,",
"North, south, east, and west.",
"When we make a map",
"we must include a compass rose.",
"It shows directions,",
"North, south, east, and west.",

"© Smart Board Learning, LLC. All rights reserved.",] },

  // 1.G.2 — Humans & environment
  { title: "Surviving Seasons", slug: "survivingseasons", standardNumber: "1.G.2", description: "", gameType: "multipleChoice", titleImage: "", video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fsocial-studies-videos%2Fsurvivingseasons2022.mp4?alt=media&token=6b4da363-4ebc-46ae-ace2-4993a44cb1dc", music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fsocial-studies-music%2FSURVIVING%20SEASONS%20(VS.2e).mp3?alt=media&token=09a254e9-ed63-47c6-95cf-65d75dfd8d5f", lyrics: ["(verse)",
"In the Winter,",
"we hunted birds.",
"In the Winter,",
"we hunted animals.",

"In the Spring,",
"we fished, hunted and picked berries.",
"In the Spring,",
"we fished, hunted and picked berries.",

"In the Summer we grew crops,",
"beans, corn, and squash.",
"In the Summer we grew crops,",
"beans, corn and squash.",

"In the Fall we picked our crops.",
"We hunted for food to store for the Winter.",
"In the Fall we picked our crops.",
"We hunted for food to store for the Winter.",

"(chorus)",
"How do we survive the Seasons?",
"How do we survive the Seasons?",

"© Smart Board Learning, LLC. All rights reserved.",] },
  // 1.G.2.2 — (no direct song match)

  // 1.H.1 — People/events changing society
  { title: "People", slug: "people", standardNumber: "1.H.1", description: "", gameType: "multipleChoice", titleImage: "", video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fpeople2025video.mp4?alt=media&token=957a3212-a73d-4f78-a3b1-dc6a4079acd3", music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fpeople2025song.mp3?alt=media&token=8359150c-fa84-4aa0-8283-e4a3fe001ef4", lyrics: ["(chorus)",
"People from our past.",
"These are people from our past.",

"(verse)",
"George Washington was our 1st President.",
"George Washington was our 1st President.",
"He was called the Father of our Country.",
"He was called the Father of our Country.",
"Abraham Lincoln was our 16th President.,",
"Abraham Lincoln was our 16th President.",
"He was called Honest Abe.",
"He was called Honest Abe.",
"Betsy Ross, a long time ago, had sewn one of the first American flags.",
"Betsy Ross, a long time ago, had sewn one of the first American flags.",

"(chorus)",
"People from our past.",
"These are people from our past.",
"These are people from our past.",

"(verse)",
"George Washington was our 1st President.",
"George Washington was our 1st President.",
"He was called the Father of our Country.",
"He was called the Father of our Country.",
"Abraham Lincoln was our 16th President.",
"Abraham Lincoln was our 16th President.",
"He was called Honest Abe.",
"He was called Honest Abe.",
"Betsy Ross, a long time ago, had sewn one of the first American flags.",
"Betsy Ross, a long time ago, had sewn one of the first American flags.",

"(chorus)",
"People from our past.",
"These are people from our past.",
"These are people from our past.",

"© Smart Board Learning, LLC. All rights reserved.",] },



];
export default topics;